import { Config } from "../../../api/config";
export var PDICheckMandatoryFields = {
    Remarks: 'Remarks',
    // InspectionResult: 'InspectionResult',
    // Value:'Value',
    CustomerVoiceName: 'CustomerVoiceName',
    ObservationId: 'ObservationId',
    DefectCategoryId: 'DefectCategoryId',
    ActionTakenId: 'ActionTakenId'
};
export var PDICheckKeys = {
    FilterPaging: 'FilterPaging',
    PagingCount: 'PDIPagingCount',
    Paging: 'PDIPaging',
    PDICheckCreateAttachment: 'PreDeliveryCheck',
    PDICheckUploadAttachment: 'PDICheckUploadAttachment',
    PDICheckSavedSelectdFilter: 'PDICheckSavedSelectdFilter',
    PDICheckSaveFilter: 'PDICheckSaveFilter',
    PDICheckServiceAdvisor: 'PDICheckServiceAdvisor',
    PDICheckTechnician: 'PDICheckTechnician',
    PDICheckVehicleModel: 'PDICheckVehicleModel',
    ViewPDICheck: 'ViewPDICheck',
    ConfigurationPDICheck: 'ConfigurationPDICheck',
    InpectionQuestionPDICheck: 'InpectionQuestionPDICheck',
    UpsertPDICheck: 'UpsertPDICheck',
    SearchPDICheck: 'SearchPDICheck'
};
export var pdiCheckPagingUrl = "".concat(Config.baseURL, "PreDeliveryCheck/Paging");
export var pdiPagingCountUrl = "".concat(Config.baseURL, "PreDeliveryCheck/PDIStatusCount");
export var selectedSavedFilter = "".concat(Config.baseURL, "IdentityPersonalization/ProxyByKey");
export var saveFilterUrl = "".concat(Config.baseURL, "IdentityPersonalization/ProxyCreate");
export var serviceAdvisorListUrl = "".concat(Config.baseURL, "IdentityOrganizationAccessRight/GetServiceAdvisor");
export var technicianListUrl = "".concat(Config.baseURL, "OrganizationEmployee/Technicians");
export var vehicleModelUrl = "".concat(Config.baseURL, "Product/ChannelList");
export var configurationUrl = "".concat(Config.baseURL, "OrganizationModulesItemSetting/GetByChannelId");
export var preCheckQuestionsUrl = "".concat(Config.baseURL, "PreDeliveryCheck/PreCheckQuestions");
export var pdiCheckUpsertsUrl = "".concat(Config.baseURL, "PreDeliveryCheck/Upsert");
export var viewPDIUrl = function (id) { return "".concat(Config.baseURL, "PreDeliveryCheck/").concat(id, "/GetPDIWithDetails"); };
export var pdiCreateAttachmentUrl = "".concat(Config.baseURL, "PreDeliveryCheckAttachment/Create");
export var pdiResourceAttachmentUrl = function (id) { return "".concat(Config.baseURL, "resource/PreDeliveryCheckAttachment/").concat(id); };
export var pdiSearchUrl = function (key, Value, OrganizationId) { return "".concat(Config.baseURL, "PreDeliveryCheck/ChassisData?Key=").concat(key, "&Value=").concat(Value, "&OrganizationId=").concat(OrganizationId); };
// export const pdiResourceAttachmentUrl = (UploadedAttachmentId: string) => `${Config.baseURL}resource/PreDeliveryCheckAttachment/${UploadedAttachmentId}`
